import { BaseModel, DatePeriod } from "../CommonModel/BaseModel";
import { FSTypeMap } from "../StateModel/FiscalPeriodInfoStateModel";

export const ValidFiscalPeriods = {
    FinancialStatementTypes: ["BS", "PL"],
    ConsolidationTypesSelected: ["NonConsolidated"],
    AccountingStandardTypesSelected: ["JP", "US", "IFRS"]
}

export const AccountingStandardTypes = [
    {
        Value: FSTypeMap.JP,
        Name: "JP",
        DisplayText: "日本基準"
    },
    {
        Value: FSTypeMap.IFRS,
        Name: "IFRS",
        DisplayText: "IFRS"
    },
    {
        Value: FSTypeMap.US,
        Name: "US",
        DisplayText: "米国基準"
    },
]

export const FinancialStatementTypes = [
    {
        Value: 0,
        Name: "BS",
        DisplayText: "貸借対照表"
    },
    {
        Value: 1,
        Name: "PL",
        DisplayText: "損益計算書"
    }
]

export class FiscalPeriodResponseModel extends BaseModel {
    constructor(obj) {
        super(obj);
        this.FiscalPeriods = obj.FiscalPeriods.reverse().map((item) => {
            let fsModels = item.TargetFinancialStatements; // Array TargetFinancialStatement
            if (fsModels) {
                let isValidFS = false;
                for (let i = 0; i < fsModels.length; ++i) {
                    if (ValidFiscalPeriods.FinancialStatementTypes.find(e => e === fsModels[i].FinancialStatementType) &&
                        ValidFiscalPeriods.ConsolidationTypesSelected.find(e => e === fsModels[i].ConsolidationType) &&
                        ValidFiscalPeriods.AccountingStandardTypesSelected.find(e => e === fsModels[i].AccountingStandardType)) {
                        isValidFS = true;
                    }
                }
                if (isValidFS)
                    return new FiscalPeriod(item);
            }

            return null;
        });
    }

    GetDisplayFiscalPeriods() {
        return this.FiscalPeriods.map((item, index) => ({
            Index: index,
            DisplayText: item.DisplayText
        }));
    }

    GetTargetFinancialStatements(index) {
        if (this.FiscalPeriods.length < index)
            return null;

        return this.FiscalPeriods[index].TargetFinancialStatements;
    }

    GetFiscalPeriodsByIndex(index) {
        if (this.FiscalPeriods.length < index)
            return null;

        return this.FiscalPeriods[index];
    }

    GetTargetAccountingStandardTypes(index) {
        if (this.FiscalPeriods.length < index)
            return null;

        let accTypes = this.FiscalPeriods[index].TargetFinancialStatements.map((item) => {
            return item.AccountingStandardType;
        });

        let uniqueAccTypes = [...new Set(accTypes)];

        let result = [];
        AccountingStandardTypes.forEach((item) => {
            if (uniqueAccTypes.includes(item.Name)) {
                result.push(item);
            }
        });

        return result;
    }

    GetTargetFinancialStatementTypes(index) {
        if (this.FiscalPeriods.length < index)
            return null;

        let fsTypes = this.FiscalPeriods[index].TargetFinancialStatements.map((item) => {
            return item.FinancialStatementType;
        });

        let uniqueFsTypes = [...new Set(fsTypes)];

        let result = [];
        FinancialStatementTypes.forEach((item) => {
            if (uniqueFsTypes.includes(item.Name)) {
                result.push(item);
            }
        });

        return result;
    }

}

export class FiscalPeriod {
    constructor(obj) {
        this.BusinessYearDisplayText = obj.BusinessYearDisplayText;
        this.BusinessYearCount = obj.BusinessYearCount;
        this.BusinessYearPeriod = new DatePeriod(obj.BusinessYearPeriod);
        this.QuarterIndex = obj.QuarterIndex;
        this.DisplayText = obj.DisplayText;
        this.YearToDate = new DatePeriod(obj.YearToDate);
        this.AccountingPeriod = new DatePeriod(obj.AccountingPeriod);
        this.TargetFinancialStatements = obj.TargetFinancialStatements.map((item) => new TargetFinancialStatement(item));
    }
}

export class TargetFinancialStatement {
    constructor(obj) {
        this.AccountingStandardType = obj.AccountingStandardType;
        this.ConsolidationType = obj.ConsolidationType;
        this.FinancialStatementType = obj.FinancialStatementType;
    }
}